import React, { useEffect } from "react";

import { CircularProgress, Stack, Typography } from "@mui/material";
import { IEmail } from "store/types";

import { useEmailsContext } from "../context/Email-context";
import { ListItem } from "./ListItem";

interface Props {}

export const List: React.FC<Props> = () => {
  const { scrollContainerRef, emailsData, loading, selectedEmails } = useEmailsContext();

  const isEmailSelected = (email: IEmail) => {
    return selectedEmails.some((e) => e.id === email.id);
  };

  // Scroll to top when data changes
  useEffect(() => {
    if (scrollContainerRef?.current && !loading) {
      scrollContainerRef.current.scrollTop = 0;
    }
  }, [loading]);

  return loading ? (
    <Stack sx={{ height: "450px", display: "flex", justifyContent: "center", alignItems: "center" }}>
      <CircularProgress size={50} />
    </Stack>
  ) : (
    <Stack
      direction="column"
      gap="5px"
      sx={{ overflow: "auto", flex: 1, paddingRight: "10px" }}
      ref={scrollContainerRef}
    >
      {emailsData?.map((item) => <ListItem key={item.id} email={item} checked={isEmailSelected(item)} />)}
      {Boolean(!emailsData?.length) && (
        <Stack sx={{ height: "100%", display: "flex", justifyContent: "center", alignItems: "center" }}>
          <Typography>No emails found</Typography>
        </Stack>
      )}
    </Stack>
  );
};
